/*
==========================================================
CLIENT TYPE OPTIONS
==========================================================
*/

export const CLIENT_TYPE = [

  {
    value: "",
    label: "Todos"
  },

  {
    value: "person",
    label: "Persona"
  },

  {
    value: "company",
    label: "Empresa"
  }

];